"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormFormulaMapping = void 0;
const typeorm_1 = require("typeorm");
const form_1 = require("./form");
const opportunity_1 = require("../opportunity");
let OrderFormFormulaMapping = class OrderFormFormulaMapping {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], OrderFormFormulaMapping.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], OrderFormFormulaMapping.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => form_1.Form),
    __metadata("design:type", form_1.Form)
], OrderFormFormulaMapping.prototype, "form", void 0);
__decorate([
    (0, typeorm_1.Column)('uuid', {
        name: 'form_id',
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "formId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity, {
        nullable: true,
    }),
    __metadata("design:type", opportunity_1.Opportunity)
], OrderFormFormulaMapping.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'opportunity_id',
        nullable: true,
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "opportunityId", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "servicesFormula", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "productsFormula", void 0);
__decorate([
    (0, typeorm_1.Column)('char', {
        name: 'name_generated',
        length: 7,
        default: () => 'gid_generate_color()',
    }),
    __metadata("design:type", String)
], OrderFormFormulaMapping.prototype, "nameGenerated", void 0);
OrderFormFormulaMapping = __decorate([
    (0, typeorm_1.Check)('offm_color_hex_constraint', `'nameGenerated' IS NULL OR 'nameGenerated' ~* '^#[a-f0-9]{6}$'::text`),
    (0, typeorm_1.Unique)('UQ_offm_name_generated', ['opportunity', 'form', 'nameGenerated']),
    (0, typeorm_1.Entity)('order_form_formula_mapping', { schema: 'order_intake_forms' })
], OrderFormFormulaMapping);
exports.OrderFormFormulaMapping = OrderFormFormulaMapping;
//# sourceMappingURL=order-form-formula-mapping.js.map